import React from "react";
import Widget from "./Widget";
import { SubTitle, InfoWrapper, InfoList, MiningAlert } from "./Widget.styled";
import { observer } from "mobx-react-lite";
import NoDataAvailable from "./NoDataAvailable";
import { useStore } from "../../../../../hooks";
import Spinner from "../../../../../components/common/Spinner";
import AISuggestionButton from "./AISuggestionButton";

const Opportunity = observer(() => {
  const { unifiedCustomerProfileStore, assistanceUCPStore } = useStore();

  const handleSuggestionClick = (title) => () => {
    const cardTypeMapping = {
      "Contract Alert": "contractsAlert",
      "Warranty Alert": "warrantyAlert",
      "Upgrade Alert": "upgradeAlert",
      "Service Alert": "serviceAlert",
      "In Market Alert": "inMarketAlert",
      "Pending Service": "pendingServicesAlert",
      "Mileage Alert": "mileageAlert",
      "Flex Alert": "flexAlert",
    };

    const cardType = cardTypeMapping[title];

    assistanceUCPStore.setCurrentCardType(cardType);
    assistanceUCPStore.setShowSuggestions(true);
    assistanceUCPStore.setSelectedTab('Chat');
  };

  return (
    <Widget title="Opportunities" height="480px">
      {unifiedCustomerProfileStore.vinChangedLoading ? (
        <Spinner />
      ) : (
        <InfoWrapper>
          {unifiedCustomerProfileStore.opportunitiesInfo?.length === 0 ? (
            <NoDataAvailable />
          ) : (
            <InfoList>
              {unifiedCustomerProfileStore.opportunitiesInfo?.map((alert, index) => (
                alert.display ?
                <MiningAlert key={index}>
                  <div>
                    <SubTitle>{alert.title}</SubTitle>
                    <span>{alert.content}</span>
                  </div>
                  <div>
                    <AISuggestionButton onClick={handleSuggestionClick(alert.title)} />
                  </div>
                </MiningAlert>
                : null
              ))}
            </InfoList>
          )}
        </InfoWrapper>
      )}
    </Widget>
  );
});

export default Opportunity;
